<template>
  <div class="content">
    <div @click="changePerson">
      <el-row style="height: 1rem;background-color: #fff;margin-bottom: .1rem;color: #666666;">
        <el-col :span="5">
          <div style="height: 1rem;line-height: 1rem;margin-left: .3rem">{{$storage.get('patient').clinic_patient_name}}</div>
        </el-col>
        <el-col :span="16">
          <div style="height: 1rem;line-height: 1rem;">
            <span>{{$storage.get('patient').clinic_num?$storage.get('patient').clinic_num:'000000'}}</span>
            <span style="float: right;color:#e02c06;font-weight: 700;font-size: .32rem">换人</span>
          </div>
        </el-col>
        <el-col :span="3">
          <div style="height: 1rem;line-height: 1.3rem;padding-left: .1rem;">
            <img src="static/img/huanren.png" style="width: .5rem;height: .5rem"/>
          </div>
        </el-col>
      </el-row>
    </div>
    <div>
      <el-row class="content-line">
        <el-col :span="8" class="title">就诊科室</el-col>
        <el-col :span="14" class="text">{{$route.query.ks}}</el-col>
      </el-row>
      <el-row class="content-line">
        <el-col :span="8" class="title">就诊医生</el-col>
        <el-col :span="14" class="text">{{$route.query.doctor}}</el-col>
      </el-row>
      <el-row class="content-line">
        <el-col :span="8" class="title">预约日期</el-col>
        <el-col :span="14" class="text" style="color: #409EFF">{{$route.query.date}}</el-col>
      </el-row>
      <el-row class="content-line">
        <el-col :span="8" class="title">预约时间</el-col>
        <el-col :span="14" class="text" style="color: #409EFF">{{$route.query.dated}}</el-col>
      </el-row>
      <el-row class="content-line" style="margin-top: .1rem">
        <el-col :span="8" class="title">支付金额</el-col>
        <el-col :span="14" class="text" style="color: rgb(230, 162, 60)">￥{{$route.query.money}}</el-col>
      </el-row>
      <el-row class="content-line">
        <el-col :span="20" class="title">费用明细</el-col>
      </el-row>
      <el-row class="content-line">
        <el-col :span="20" class="title">
          <el-checkbox v-model="checked"></el-checkbox>&nbsp我已阅读并了解
          <el-button type="text" @click="innerDialog = true">《挂号须知》</el-button>
        </el-col>
      </el-row>
      <el-dialog title="门诊挂号须知" :visible.sync="innerDialog" width="90%">
        <div v-html="config_context"></div>
        <div style="width: 100%;height: .6rem;text-align: center">
          <el-button type="text" style="font-size: .3rem" @click="innerDialog = false;checked=true">我知道了</el-button>
        </div>
      </el-dialog>
    </div>
    <div style="width: 100%;text-align: center;margin-top: .6rem;">
      <el-button type="primary" style="width: 6rem;font-size: .32rem" @click="confirmDd">确定订单</el-button>
    </div>
  </div>
</template>

<script>
  import {GetMznotice} from '../../api/index'
    export default {
      data(){
        return{
          checked:false,
          innerDialog:true,
          config_context:'',
        }
      },
      created() {
        //修改标题
        document.title = '确定挂号信息'
        GetMznotice().then(res=>{
          this.config_context = res.Data.config_context
        })
      },
      methods:{
        //切换病人
        changePerson(){
          this.$router.push({path:'/selectPerson'})
        },
        //确定订单
        confirmDd(){
          if(!this.checked){
            this.$message({
              message: '请先确定阅读挂号须知',
              type: 'warning',
              duration:3000,
              center:true,
              offset:200
            });
            return
          }
          //questionnaire1 payment
          if(this.$storage.get('patients').length===1){
            this.$router.push({path:'/questionnaire1',query:{
              money:this.$route.query.money,
              ksId:this.$route.query.ksId,
              ks:this.$route.query.ks,
              doctor:this.$route.query.doctor,
              doctorId:this.$route.query.doctorId,
              date:this.$route.query.date,
              dated:this.$route.query.dated,
              hyxlh:this.$route.query.hyxlh,
              pbxlh:this.$route.query.pbxlh,
            }})
            return;
          }
          this.$confirm('该挂号就诊人为：'+this.$storage.get('patient').clinic_patient_name, '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '换人',
            type: 'warning'
          }).then(() => {
            //questionnaire1 payment
            this.$router.push({path:'/questionnaire1',query:{
              money:this.$route.query.money,
              ksId:this.$route.query.ksId,
              ks:this.$route.query.ks,
              doctor:this.$route.query.doctor,
              doctorId:this.$route.query.doctorId,
              date:this.$route.query.date,
              dated:this.$route.query.dated,
              hyxlh:this.$route.query.hyxlh,
              pbxlh:this.$route.query.pbxlh,
            }})
          }).catch(() => {
            this.changePerson()
          });
        }
      }
    }
</script>

<style scoped>
  .content{
    width: 100%;
    height: 100vh;
    font-size: .28rem;
    background-color: #f4f4f4;
  }
  .content-line{
    height: .8rem;
    background-color: #FFFFFF;
    margin-bottom: 1px;
  }
  .title{
    line-height: .8rem;
    margin-left: .3rem;
    color: #666666;
  }
  .text{
    line-height: .8rem;
    text-align: right;
  }
  /*去掉element-ui的drawer标题选中状态*/
  /deep/ :focus{
    outline:0;
  }
</style>



// WEBPACK FOOTER //
// src/components/pages/confirmRegistration.vue